/**
 * Format a duration in seconds to a human-readable string (H:MM:SS or M:SS).
 *
 * @param totalSeconds - Total duration in seconds
 * @returns Formatted duration string
 *
 * @example
 * formatDuration(225) // "3:45"
 * formatDuration(3750) // "1:02:30"
 * formatDuration(60) // "1:00"
 */
export function formatDuration(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }

  return `${minutes}:${String(secs).padStart(2, "0")}`;
}
